import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d8d6acc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex-1 w-full mt-0 mb-2",
  "data-cy": "pdf-overview-generalinfo-table"
}
const _hoisted_2 = {
  class: "data-tr border-top border-bottom",
  "data-cy": "generalinfo-table-heizzentrale"
}
const _hoisted_3 = {
  style: {"min-width":"120px","max-width":"200px"},
  class: "pl-2"
}
const _hoisted_4 = { class: "pl-2" }
const _hoisted_5 = { class: "font-semibold" }
const _hoisted_6 = {
  style: {"min-width":"120px","max-width":"200px"},
  class: "pl-2"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Zugangsart: ")
const _hoisted_8 = { class: "font-semibold" }
const _hoisted_9 = {
  style: {"min-width":"120px","max-width":"200px"},
  class: "pl-2"
}
const _hoisted_10 = { class: "font-semibold" }
const _hoisted_11 = {
  class: "data-tr",
  "data-cy": "generalinfo-table-waermeerzeuger"
}
const _hoisted_12 = ["rowspan"]
const _hoisted_13 = {
  style: {"min-width":"120px","max-width":"200px"},
  class: "pl-2 border-bottom"
}
const _hoisted_14 = { "data-cy": "generalInfo-energietraeger" }
const _hoisted_15 = { class: "font-semibold" }
const _hoisted_16 = { class: "font-semibold" }
const _hoisted_17 = { class: "pl-2 border-bottom" }
const _hoisted_18 = {
  key: 0,
  class: "text-xxs h-2.5"
}
const _hoisted_19 = { class: "pl-2 border-bottom" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Baujahr: ")
const _hoisted_21 = {
  key: 0,
  class: "h-2.5"
}
const _hoisted_22 = { "data-cy": "generalinfo-table-anlagenkomponenten" }
const _hoisted_23 = {
  colspan: "3",
  class: "pl-2"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "border-bottom" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("tr", _hoisted_2, [
      _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.t("hzba.pdf.heizzentrale", 1, { locale: _ctx.lang })), 1),
      _createElementVNode("td", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.heizraums, (heizraum, key) => {
          return (_openBlock(), _createElementBlock("div", {
            key: key,
            "data-cy": "generalInfo-standort"
          }, [
            _createTextVNode(" Heizraum " + _toDisplayString(key +1) + ": " + _toDisplayString(_ctx.useIdentifierFrageFinder(
              _ctx.hzba,
              "hzba.heizzentrale-tab.allgemein-group.allgemein-modal.allgemein.standort"
            )?.getTitle() || "Standort") + ": ", 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(heizraum
                .findFrageByRelativePath(
                  _ctx.hzba,
                  "allgemein-modal.allgemein.standort"
                )
                ?.getSelectedAuswahlLabelsString() || "Keine Angabe"), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("td", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.heizraums, (heizraum, key) => {
          return (_openBlock(), _createElementBlock("div", {
            key: key,
            "data-cy": "generalInfo-zugangsart"
          }, [
            _hoisted_7,
            _createElementVNode("span", _hoisted_8, _toDisplayString(heizraum
                .findFrageByRelativePath(
                  _ctx.hzba,
                  "allgemein-modal.allgemein.zugangsart"
                )
                ?.getSelectedAuswahlLabelsString() || "-"), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("td", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.heizraums, (heizraum, key) => {
          return (_openBlock(), _createElementBlock("div", {
            key: key,
            "data-cy": "generalInfo-heizraumtuer"
          }, [
            _createTextVNode(_toDisplayString(_ctx.t("hzba.pdf.heizraumtuer", 1, { locale: _ctx.lang })) + ": ", 1),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.isBeschildert(heizraum) === true
                ? "Beschildert"
                : _ctx.isBeschildert(heizraum) === false
                ? "Nicht beschildert"
                : "Keine Angabe"), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("tr", _hoisted_11, [
      _createElementVNode("td", {
        style: {"min-width":"120px","max-width":"200px"},
        class: "pl-2",
        rowspan: _ctx.waermeerzeugers?.length + 2
      }, _toDisplayString(_ctx.t("hzba.pdf.waermeerzeugung", 1, { locale: _ctx.lang })), 9, _hoisted_12),
      _createElementVNode("td", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createTextVNode(_toDisplayString(_ctx.useIdentifierFrageFinder(
              _ctx.hzba,
              "hzba.uebersicht-tab.heizungsdaten.energietraeger"
            )?.getTitle()) + ": ", 1),
          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.useIdentifierFrageFinder(
                _ctx.hzba,
                "hzba.uebersicht-tab.heizungsdaten.energietraeger"
              )?.getSelectedAuswahlLabelsString()), 1)
        ]),
        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.useIdentifierFrageFinder(
                _ctx.hzba,
                "hzba.uebersicht-tab.heizungsdaten.energietraeger"
              )?.getSelectedAuswahlLabelsString()), 1)
      ]),
      _createElementVNode("td", _hoisted_17, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.waermeerzeugers?.slice(0, 5), (waermeerzeuger, key) => {
          return (_openBlock(), _createElementBlock("div", {
            key: key,
            "data-cy": "generalInfo-leistung"
          }, [
            _createTextVNode(" Wärmeerzeuger " + _toDisplayString(key + 1) + ": Leistung: ", 1),
            _createElementVNode("strong", null, _toDisplayString(waermeerzeuger
                .findFrageByRelativePath(
                  _ctx.hzba,
                  "allgemein-modal.allgemein.nennleistung"
                )
                ?.getCurrentInput() || "-") + " kW ", 1)
          ]))
        }), 128)),
        (_ctx.waermeerzeugers?.length > 5)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, " Weitere Wärmeerzeuger wurden gefunden. "))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("td", _hoisted_19, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.waermeerzeugers?.slice(0, 5), (waermeerzeuger, key) => {
          return (_openBlock(), _createElementBlock("div", {
            key: key,
            "data-cy": "generalInfo-baujahr"
          }, [
            _hoisted_20,
            _createElementVNode("strong", null, _toDisplayString(waermeerzeuger
              .findFrageByRelativePath(
                _ctx.hzba,
                "allgemein-modal.allgemein.baujahr"
              )
              ?.getCurrentInput() || "-"), 1)
          ]))
        }), 128)),
        (_ctx.waermeerzeugers?.length > 5)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("tr", _hoisted_22, [
      _createElementVNode("td", _hoisted_23, [
        _createElementVNode("div", null, _toDisplayString(_ctx.useIdentifierFrageFinder(
              _ctx.hzba,
              "hzba.uebersicht-tab.anlagenschema-group.kurzbeschreibunganlagenkomponenten"
            )?.getCurrentInput()), 1)
      ])
    ]),
    _hoisted_24
  ]))
}